<template>
	<div class="amount">
		<div class="minus" @click="handleMinus">
			<img src="../assets/reduce.svg" />
		</div>
		<div v-if="!editMode" class="number" @click="toggleInput">{{ value }}</div>
		<input
			v-if="editMode"
			v-model="inputValue"
			class="number-input"
			type="text"
			inputmode="decimal"
			pattern="^-?\d*(\.\d*)?$"
			@input="handleIntegerInput"
			@blur="handleInputBlur"
			@keyup.enter="handleInputBlur"
		/>
		<div :class="{ disable: disable }" class="plus" @click="handleIncrease">
			<img src="../assets/plus.svg" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'ByAmountPicker',
	props: {
		value: {
			type: Number,
			required: false,
			default: 1,
		},
		min: {
			required: false,
			type: Number,
			default: 1,
		},
		max: {
			required: false,
			type: Number,
			default: 999,
		},
		isUpdate: {
			required: false,
			type: Boolean,
			default: true,
		},
		disable: {
			required: false,
			type: Boolean,
			default: false,
		},
	},
	model: {
		prop: 'value',
		event: 'updateCount',
	},
	data() {
		return {
			editMode: false, // 編輯模式狀態
			inputValue: '',
		}
	},
	watch: {
		value(newValue) {
			this.updateValue(newValue, true)
		},
	},
	methods: {
		toggleInput() {
			if (this.disable) return

			this.editMode = !this.editMode
			this.inputValue = this.editMode ? this.value.toString() : ''
			this.$nextTick(() => {
				if (this.editMode) {
					this.$el.querySelector('.number-input').focus()
				}
			})
		},
		handleIntegerInput() {
			let sanitizedValue = String(this.inputValue).replace(/[^\d.-]/g, '')
			sanitizedValue = sanitizedValue.replace(/(?!^)-/g, '')
			if (this.min >= 0) {
				sanitizedValue = sanitizedValue.replace(/-/g, '')
			}
			const dotIndex = sanitizedValue.indexOf('.')
			if (dotIndex !== -1) {
				sanitizedValue = `${sanitizedValue.slice(0, dotIndex + 1)}${sanitizedValue.slice(dotIndex + 1).replace(/\./g, '')}`
			}
			this.inputValue = sanitizedValue
		},
		handleInputBlur() {
			const parsedValue = Number(this.inputValue)
			let newValue = Math.trunc(parsedValue)
			if (isNaN(parsedValue) || newValue < this.min) {
				newValue = this.min
			} else if (newValue > this.max) {
				newValue = this.max
			}
			this.updateValue(newValue)
			this.editMode = false
		},
		// 新值一律用區域變數算完再 emit，勿寫 this.value：value 是 prop，直接賦值除了
		// 觸發單向資料流警告，父層沒實際寫回時（如 UPDATE_CART_ITEM 缺 storeId 會整段
		// 跳過）畫面數字會與資料發散。
		// emit 順序不可調換：ComboCard 的 @onIncrease 讀的是 updateCount 寫回前的 count。
		handleIncrease() {
			if (this.disable) return

			const currentValue = Number(this.value)
			if (currentValue + 1 > this.max) {
				this.updateValue(this.max, false) // 已達上限，夾到 max
				this.isUpdate && this.$emit('updateCount', this.max)
			} else {
				const nextValue = currentValue + 1
				this.$emit('onIncrease', nextValue)
				this.isUpdate && this.$emit('updateCount', nextValue)
			}
		},
		handleMinus() {
			const currentValue = Number(this.value)
			if (currentValue - 1 < this.min) {
				this.$emit('onDelete')
				return
			}
			const nextValue = currentValue - 1
			this.$emit('onMinus', nextValue)
			this.isUpdate && this.$emit('updateCount', nextValue)
		},
		updateValue(newValue, isNormalUpdate = true) {
			if (this.value !== newValue) {
				this.$emit('updateCount', newValue)
			}
			if (!isNormalUpdate && !this.isUpdate) {
				if (newValue < this.min) {
					this.$emit('updateCount', this.min)
				} else if (newValue > this.max) {
					this.$emit('updateCount', this.max)
				}
			}
		},
	},
}
</script>
<style lang="sass" scoped>
.amount
	display: flex
	align-items: center
	justify-content: space-around
	width: 120px
	color: #432d2c

	.minus, .plus
		width: 30px

	.number
		font-weight: 900
		font-size: 16px
		width: 55px
		text-align: center

	.disable
		filter: grayscale(1)
		opacity: 0.3

	.number-input
		width: 40px
		font-size: 16px
</style>
